var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentArea',{key:_vm.instanceHash,ref:"section",class:[`${_vm.$appPrefix}-module-wrapper`, ..._vm.classList],style:(_vm.styles),attrs:{"id":_vm.anker}},[_c('div',{ref:"animation",class:_vm.animationClassList},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }